import React from 'react'
import Email from '../../../../icons/iconEmail.svg'
import Edit from '../../../../icons/edit.svg'
import { useDispatch, useSelector } from 'react-redux'
import { setConfirmationModal } from '../../../../redux/actions/confirmationModal'
import EditEmail from '../../../NestedComponents/Option 2/SettingsModals/EditEmail'

const EmailChange = () => {
  const dispatch = useDispatch()
  const {
    userDetails: { email },
  } = useSelector((state) => state)
  const handleEditClickEmail = () => {
    dispatch(
      setConfirmationModal({
        headerText: 'Email bearbeiten',
        body: <EditEmail />,
        large: true,
        headerBorder: true,
        modalFromSettings: true,
      }),
    )
  }
  return (
    <div>
      <div>
        <img src={Email} alt={Email} />
      </div>
      <div>
        <p>Email Adresse</p>
        <p>{email}</p>
      </div>
      <div onClick={handleEditClickEmail}>
        <img src={Edit} alt={Edit} />
      </div>
    </div>
  )
}

export default EmailChange
